export default __webpack_public_path__ + "static/media/bgphone.3171003e.png";